export default {"src":"/_next/static/media/icon-reward-reward.161a1231.svg","height":33,"width":41,"blurWidth":0,"blurHeight":0};